/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliGroupDto } from '../../models/amoxcalli-group-dto';

export interface ApiGroupsIdGet$Plain$Params {
  id: string;
}

export function apiGroupsIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiGroupsIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliGroupDto>> {
  const rb = new RequestBuilder(rootUrl, apiGroupsIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliGroupDto>;
    })
  );
}

apiGroupsIdGet$Plain.PATH = '/api/groups/{id}';
